import { gql } from "@apollo/client";

export const GET_VALET_ADDON_PRICE = gql`
  query getValetAddonPrice($branchInfo: BranchInfo, $coordinates: Coordinates) {
    getValetAddonPrice(branchInfo: $branchInfo, coordinates: $coordinates)
  }
`;
